import React, { Component, ErrorInfo, ReactNode } from "react";
import somethingWrong from "./assets/images/something-went-wrong.jpg";
import {WrongContainer} from "./assets/styles/globalStyle";
import * as Sentry from "@sentry/react";
interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Sentry.ErrorBoundary>
          <WrongContainer className="wrong-wrapper">
            <div className="wrong-wrapper-content">
              <img src={somethingWrong} alt="" />
              <h1>Oops! Something went wrong</h1>
              <p>Brace yourself till we get the error fixed</p>
            </div>
          </WrongContainer>
        </Sentry.ErrorBoundary>
      )
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
